import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import React from 'react';
import './EmptyState.scss';

const EmptyState = function init(props: IEmptyState): React.ReactElement {
    const {
        image,
        placeholder,
        caption
    }: IEmptyState = props;
    return (
        <div className="empty-state--container">
            <img
                className="empty-state--image"
                src={image.src}
                alt={image.alt}
            />
            <p className="empty-state--placeholder">{placeholder}</p>
            <span className="empty-state--caption">{caption}</span>
        </div>
    );
};

export default EmptyState;
